import { useEffect } from 'react';

interface SeoConfig {
  title: string;
  description?: string;
  keywords?: string;
}

function setMeta(name: string, content: string) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/**
 * Sets the document title and description/keywords meta tags for a page.
 */
export function useSeo({ title, description, keywords }: SeoConfig) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);
  }, [title, description, keywords]);
}